// AnimatedDice.js
import React, { useEffect } from "react";
import "./AnimatedDice.css";

export default function AnimatedDice({ isRolling, onDone }) {
  useEffect(() => {
    if (isRolling) {
      const timer = setTimeout(() => {
        const face = Math.floor(Math.random() * 6) + 1;
        onDone && onDone(face);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isRolling, onDone]);

  return (
    <div className="dice-container">
      <div className={`dice ${isRolling ? "roll" : ""}`}>
        {/* You could show something else if you prefer images or final face. */}
      </div>
    </div>
  );
}
